/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserSummaryDto { 
    id?: number;
    userName?: string | null;
    name?: string | null;
    middleName?: string | null;
    surname?: string | null;
    emailAddress?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    isActive?: boolean;
    fullName?: string | null;
    lockoutEndDateUtc?: string;
    forgotPaaswordLockoutDateUTC?: string;
    verifyOtpLockoutDateUTC?: string;
    isLocked?: boolean | null;
}

